import { TrackingService } from './tracking_service';
import { TrackingFeatureLabels } from './types';


export class ToAllBrandsLink {
    private readonly trackingService: TrackingService;
    private readonly _featureOrder: number;
    private readonly masFeatureTrackingLabels: TrackingFeatureLabels;
    private readonly masNextPiTrackingLabels: TrackingFeatureLabels;
    private readonly _item: HTMLLinkElement;
    private readonly targetUrl: string;

    constructor(private container: Element) {
        this._item = container.querySelector('.promo-brandpromo__to-all-brands-link a')!;
        this._featureOrder = this.getFeatureOrder(this.container);
        this.masFeatureTrackingLabels = this.getMasFeatureTrackingLabels(container);
        this.masNextPiTrackingLabels = this.getMasNextPiTrackingLabels(container);
        this.trackingService = new TrackingService();
        this.targetUrl = this._item.getAttribute('href')!;

        this.trackLoaded();
        this._item.addEventListener('click', (e: MouseEvent) => this.trackClick(e), false);
        this.registerVisibleTrackObserver();
    }

    trackClick(e: MouseEvent): void {
        if (e.target instanceof Element) {
            this.trackingService.sendToAllBrandsLinkClickTrackingEvent(this._featureOrder, this.masFeatureTrackingLabels, this.masNextPiTrackingLabels, this.targetUrl);
        }
    }

    trackLoaded(): void {
        this.trackingService.sendToAllBrandsLinkInitialLoadedTrackingEvent(this._featureOrder, this.targetUrl, this.masFeatureTrackingLabels);
    }

    registerVisibleTrackObserver(): void {
        /*                                     */
        const observer = new IntersectionObserver((entries) => {
            const intersectingEntries = entries.filter((entry) => entry.isIntersecting);
            if (intersectingEntries.length > 0) {
                this.trackingService.sendVisibleTrackingEvent(`ft3_tabl`, `ft3_tabl_tile0`);
                observer.unobserve(this.container);
            }
        }, {});

        observer.observe(this.container);
    }

    private getMasFeatureTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataFeatureTrackingLabels = container.closest('[data-feature-tracking-labels]')?.getAttribute('data-feature-tracking-labels');
        return dataFeatureTrackingLabels ? JSON.parse(dataFeatureTrackingLabels) : {};
    }

    private getMasNextPiTrackingLabels(container: Element): TrackingFeatureLabels {
        const dataMasNextPiTrackingLabels = container.closest('[data-next-pi-tracking-labels]')?.getAttribute('data-next-pi-tracking-labels');
        return dataMasNextPiTrackingLabels ? JSON.parse(dataMasNextPiTrackingLabels) : {};
    }

    private getFeatureOrder(container: Element): number {
        const dataFeatureOrder = container.closest('[data-feature-order]')?.getAttribute('data-feature-order');
        return dataFeatureOrder ? parseInt(dataFeatureOrder, 0) : -1;
    }

    /*            */
    get featureOrder(): number {
        return this._featureOrder;
    }

    /*            */
    get item(): HTMLLinkElement {
        return this._item;
    }

    /*            */
    get testContainer(): Element {
        return this.container;
    }

}